#!/usr/bin/env node

import { runServer } from './server.js';
import { logger } from './lib/logger.js';

// Handle uncaught errors
process.on('uncaughtException', (error) => {
  logger.error('Uncaught exception', { error: error.message, stack: error.stack });
  process.exit(1);
});

process.on('unhandledRejection', (reason) => {
  logger.error('Unhandled rejection', { reason });
  process.exit(1);
});

// Start the server
runServer().catch((error) => {
  logger.error('Failed to start server', { error: error.message });
  process.exit(1);
});
